import { useEffect, useRef, useState } from "react";
import { useOutsideClickHandler } from "../../../../Hooks/useOutsideClick";
import { closeModal, setSelectedVariant } from "../../../../Features/inventoryManagementSlice";
import { useDispatch, useSelector } from "react-redux";
import Cross from '../../../../Assets/Modals/closeIcon.svg';
import ChevronDown from '../../../../Assets/ChevronDownLargeDarkMode.svg';
import { useNavigate } from "react-router-dom";
import { showToast } from "../../../../Components/Toaster/Toaster";

function SelectVariantToEdit() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const wrapperRef = useRef(null);

    const selectedProduct = useSelector((state) => state.inventoryManagement.selectedProduct);
    const selectedVariant = useSelector((state) => state.inventoryManagement.selectedVariant);
    const [productCategory, setProductCategory] = useState('');

    useOutsideClickHandler(wrapperRef, () => {
        handleCloseModal();
    });

    const dropdownButtonRef = useRef(null);
    const dropdownListRef = useRef(null);

    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [buttonAvailable, setButtonAvailable] = useState(false);

    const handleDropdownButton = () => {
        setDropdownOpen(!dropdownOpen);
    }

    function handleCloseModal() {
       dispatch(closeModal());
        dispatch(setSelectedVariant({}));
    }

    function handleSelectVariant(variant) {
        dispatch(setSelectedVariant(variant));
    }

    function handleNext() {
        if(buttonAvailable) {
            navigate('edit-variant');
            dispatch(closeModal());
        }
        else {
            showToast('Please select a variant.', 'warning');
            return;
        }
    }

    useEffect(() => {
        if(Object.keys(selectedVariant).length > 0) {
            setButtonAvailable(true);
        }
        else {
            setButtonAvailable(false);
        }
    }, [selectedVariant]);

    useEffect(() => {
        if (Object.keys(selectedProduct || {}).length === 0) return;

        setProductCategory(selectedProduct?.product?.productCategory || '');
    }, [selectedProduct]);

    return (
        <div ref={wrapperRef} className='w-[44%] bg-[#FFFFFF] border border-[#EAEAEA] rounded-[9px] p-4 flex flex-col gap-4'>
            <div className="flex flex-col gap-3">
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                        <h1 className='font-semibold text-2xl text-[#121212]'>Edit Variant</h1>
                    </div>

                    <button onClick={handleCloseModal} className="w-11 h-11 flex items-center justify-center">
                        <img src={Cross} alt="" />
                    </button>
                </div>

                <div className="flex flex-col gap-3">
                    <h1 className='font-medium text-base text-[#121212]'>Variants</h1>

                    <div onClick={handleDropdownButton} ref={dropdownButtonRef} className={`relative cursor-pointer flex items-center justify-between gap-[10px] px-3 py-4 bg-[#F5F5F5] border border-[#EAEAEA] rounded-[9px] ${dropdownOpen && 'border-primaryColor'}`}>
                        <p className='font-normal w-[calc(100%-24px)] text-base text-[#666666] select-none line-clamp-1'>
                            {Object.keys(selectedVariant).length > 0
                                ? `${productCategory === 'Beauty & Personal Care' ? 'Volume' : 'Size'}: ${selectedVariant?.VarientSize ?? '(Not Set)'}${selectedVariant?.VarientColor?.length > 0 ? `, Color: ${selectedVariant?.VarientColor ?? ''}` : ''}`
                                : 'select variant'}
                        </p>

                        <div className="size-6 flex items-center justify-center select-none">
                            <img src={ChevronDown} alt="" />
                        </div>

                        {
                            dropdownOpen && Object.keys(selectedProduct).length > 0 &&
                            (
                                Object.keys(selectedProduct).length > 0 &&
                                <>
                                    <div ref={dropdownListRef} className="bg-[#FFFFFF] max-h-56 overflow-y-scroll absolute z-10 top-[58px] left-0 w-full rounded-[9px] shadow-[0px_3px_6px_0px_#0000001F]">
                                        {selectedProduct.varients?.map(variant => {
                                            return (
                                                <p key={variant.id} onClick={() => handleSelectVariant(variant)} className='px-3 py-4 font-medium text-base text-[#666666] select-none hover:bg-[#F5F5F5]'>
                                                    {productCategory === 'Beauty & Personal Care' ? 'Volume' : 'Size'}: {variant?.VarientSize ?? '(Not Set)'}{variant?.VarientColor?.length > 0 ? `, Color: ${variant.VarientColor}` : ''}
                                                </p>
                                            );
                                        })}
                                    </div>
                                </>
                            )
                        }
                    </div>
                </div>
            </div>

            <button onClick={handleNext} className={`px-4 py-2 ${buttonAvailable ? 'bg-primaryColor hover:bg-primaryAccent' : 'bg-buttonDisabledBg cursor-not-allowed'} text-buttonText rounded font-semibold text-base`}>Next</button>
        </div>
    );
}

export default SelectVariantToEdit;
